<template>
    <div class="Layout">
        <web-nav ref="webNav"></web-nav>
        <div class="main-container" :style="{minHeight: browserHeight-250-80+'px'}">
            <router-view />
        </div>
        <bottom ref="bottom"></bottom>
    </div>
</template>

<script>
import webNav from "@/components/webNav";
import bottom from "@/components/bottom"
export default {
    components:{webNav,bottom},
    name: "Layout",
    data(){
        return{
            browserHeight:0,
        }
    },
    methods:{
        updateBrowserHeight(){
            this.browserHeight = window.innerHeight;
        }
    },
    mounted() {
        this.updateBrowserHeight();
        window.addEventListener('resize', this.updateBrowserHeight);
    }
}
</script>

<style scoped lang="scss">
.main-container{
    background: rgb(245, 246, 249);
    padding-top:20px;
    box-sizing: border-box;
}
</style>
